import script from "./OutlineButton.vue?vue&type=script&setup=true&lang=js"
export * from "./OutlineButton.vue?vue&type=script&setup=true&lang=js"

import "./OutlineButton.vue?vue&type=style&index=0&id=cd6fe3f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd6fe3f4"]])

export default __exports__